const getBoxSize = (inpArr, threshold = [3, 5]) => {
  const threshold_sorted = threshold.sort();
  for (let i = 0; i < inpArr.length; i++) {
    if (inpArr[i].length >= threshold_sorted[1]) {
      return "wide";
    } else if (inpArr[i].length >= threshold_sorted[0]) {
      return "medium";
    }
  }
  return "small";
};

export { getBoxSize };
